const TOOL_DRAW_AREA = "TOOL_DRAW_AREA";
const TOOL_DRAW_LINE = "TOOL_DRAW_LINE";
const TOOL_DRAW_POINT = "TOOL_DRAW_POINT";
const TOOL_EDIT_AREA = "TOOL_EDIT_AREA";
const TOOL_EDIT_AREA_CLICK = "TOOL_EDIT_AREA_CLICK";
const TOOL_SELECT = "TOOL_SELECT";
const TOOL_GRAFFITI = "TOOL_GRAFFITI";
const TOOL_SPLIT = "TOOL_SPLIT";
const TOOL_UNION = "TOOL_UNION";
const TOOL_CULLING = "TOOL_CULLING";
const TOOL_MERGE = "TOOL_MERGE";
export {
  TOOL_DRAW_AREA,
  TOOL_DRAW_LINE,
  TOOL_DRAW_POINT,
  TOOL_EDIT_AREA,
  TOOL_EDIT_AREA_CLICK,
  TOOL_MERGE,
  TOOL_SELECT,
  TOOL_GRAFFITI,
  TOOL_SPLIT,
  TOOL_UNION,
  TOOL_CULLING
}



// WEBPACK FOOTER //
// ./src/tool/edit/ToolType.js